import { pageconfigurationsApi } from 'app/src/services/welfareportal/'
import { DefaultBodyType, http, HttpResponse } from 'msw'
import { apiBaseUrl } from './commonconfig'

const getUserInfoPageConfig = http.get<object, DefaultBodyType, pageconfigurationsApi.Page>(
  apiBaseUrl + '/:templateId/pages/userinfopage',
  () => {
    return HttpResponse.json([
      {
        id: 'userinfopage',
        sections: [
          {
            renderingMode: 'native',
            sectionName: 'InformativeBannerSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'SimpleTextSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'UserDataSection',
          },
          {
            renderingMode: 'native',
            sectionName: 'UserFamilyMembersSection',
          },
        ],
      },
    ])
  },
)

export const userinfopageConfigHandlers = [getUserInfoPageConfig]
